/**
 * Integrity v2.1: copy, cut and paste work normally INSIDE the code editor; only
 * text arriving from outside it is blocked and reported.
 *
 * A candidate writing their own code copies and cuts all the time (Ctrl+X on an
 * empty selection cuts the line), and blocking that broke ordinary editing while
 * adding no evidence: copying text out cannot bring a solution in. So a paste is
 * let through when its text is already in the editor, or was in it just before
 * the last cut. Anything else is a paste from outside. Pure.
 */
const normalize = (s) => s.replace(/\r\n?/g, '\n').trim();
export function isPasteFromEditor(pasted, sources) {
    const text = normalize(pasted || '');
    if (!text)
        return true; // nothing arrives, nothing to report
    return sources.some((src) => !!src && normalize(src).includes(text));
}
